// turning ai2html's output into a module allows
// webpack to apply hot module replacement.
// we obviously want to bake it into the html in production
// that's why we're conditionally requiring it

import { Child } from 'pym.js';
// import ai2html from './ai2html-graphic.html';
import * as d3 from 'd3';
import meta from './data/meta.json';
import Zion from './utils/Zion';

// utils
import { stylePremium } from './utils/helpers';

// styles
import './styles/index.scss';
import './styles/graphic.scss';

const pkg = require('../package.json');

let ai2html = null;

if (process.env.NODE_ENV === 'development') {
  // turning ai2html's output into a module allows
  // webpack to apply hot module replacement.
  // we obviously want to bake it into the html in production
  // that's why we're conditionally requiring it
  ai2html = require('./ai2html-graphic.html');
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

console.clear();

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

const CNNPolitics = false;
const CNNBusiness = false;

stylePremium(CNNPolitics, CNNBusiness);

function draw() {
  if (process.env.NODE_ENV === 'development') {
    // the code below applies the ai2html
    // during development mode.

    const figure = document.querySelector('#ai2html-graphic');
    figure.innerHTML = ai2html;

    // If you want to write code for this graphic,
    // move this stuff outside the if block that it's in.
  }
}


// CUSTOM D3 CODE

// const years = [2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023];

// function hideText(years, show) {
//   if (show == 'hide') {
//     years.forEach((d) => {
//       d3.selectAll(`[data-name="text${d}"]`).selectAll('text').attr('opacity', 0)
//         .style('text-shadow', 'none');
//       // d3.select(`#text${d}`).selectAll('text').attr('opacity', 0);
//     });
//   } else {
//     years.forEach((d) => {
//       d3.selectAll(`[data-name="text${d}"]`).selectAll('text').attr('opacity', 1)
//         .style('text-shadow', 'none');
//       // d3.select(`#text${d}`).selectAll('text').attr('opacity', 1);
//     });
//   }
// }

// function graphicDefault() {
//   // show all circles
//   d3.selectAll('circle').attr('opacity', 1);
//   // show all years
//   hideText(years, 'hide');

//   if (window.innerWidth < 500) {
//     d3.selectAll('[data-name="text2014"]')
//       .selectAll('text').attr('opacity', 1)
//       .attr('fill', 'white');
//     // .style('text-shadow', 'text-shadow: -1px -1px 2px #fff, 1px -1px 2px #fff, -1px 1px 2px #fff, 1px 1px 2px #fff');
//     d3.selectAll('[data-name="text2023"]').selectAll('text').attr('opacity', 1);
//   } else {
//     d3.selectAll('[data-name="text2014"]').selectAll('text').attr('opacity', 1)
//       .attr('fill', 'white');
//     // .style('text-shadow', '-1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff');
//     d3.selectAll('[data-name="text2023"]').selectAll('text').attr('opacity', 1);
//   }

//   // d3.selectAll('[data-name="text2014"]').selectAll('text').attr('display', 'block');
// }

// // d3.selectAll('#circ2014')
// d3.selectAll('[data-name="circ2014"]')
//   .on('mouseover', function () {
//     // hide all text
//     hideText(years, 'hide');
//     // except selected year
//     d3.selectAll('[data-name="text2014"]').selectAll('text').attr('opacity', 1).attr('fill', 'black');

//     // hide all circles
//     d3.selectAll('circle').attr('opacity', 0.3);
//     // except selected year
//     d3.select(this).attr('opacity', 1);
//   })
//   .on('mouseout', () => {
//     graphicDefault();
//   });

// d3.selectAll('[data-name="circ2015"]')
//   .on('mouseover', function () {
//     hideText(years, 'hide');
//     d3.selectAll('[data-name="text2015"]').selectAll('text').attr('opacity', 1);

//     d3.selectAll('circle').attr('opacity', 0.3);
//     d3.select(this).attr('opacity', 1);
//   })
//   .on('mouseout', () => {
//     graphicDefault();
//   });

// d3.selectAll('[data-name="circ2016"]')
//   .on('mouseover', function () {
//     hideText(years, 'hide');
//     d3.selectAll('[data-name="text2016"]').selectAll('text').attr('opacity', 1);

//     d3.selectAll('circle').attr('opacity', 0.3);
//     d3.select(this).attr('opacity', 1);
//   })
//   .on('mouseout', () => {
//     graphicDefault();
//   });

// d3.selectAll('[data-name="circ2017"]')
//   .on('mouseover', function () {
//     hideText(years, 'hide');
//     d3.selectAll('[data-name="text2017"]').selectAll('text').attr('opacity', 1);

//     d3.selectAll('circle').attr('opacity', 0.3);
//     d3.select(this).attr('opacity', 1);
//   })
//   .on('mouseout', () => {
//     graphicDefault();
//   });

// d3.selectAll('[data-name="circ2018"]')
//   .on('mouseover', function () {
//     hideText(years, 'hide');
//     d3.selectAll('[data-name="text2018"]').selectAll('text').attr('opacity', 1);

//     d3.selectAll('circle').attr('opacity', 0.3);
//     d3.select(this).attr('opacity', 1);
//   })
//   .on('mouseout', () => {
//     graphicDefault();
//   });

// d3.selectAll('[data-name="circ2019"]')
//   .on('mouseover', function () {
//     hideText(years, 'hide');
//     d3.selectAll('[data-name="text2019"]').selectAll('text').attr('opacity', 1);

//     d3.selectAll('circle').attr('opacity', 0.3);
//     d3.select(this).attr('opacity', 1);
//   })
//   .on('mouseout', () => {
//     graphicDefault();
//   });

// d3.selectAll('[data-name="circ2020"]')
//   .on('mouseover', function () {
//     hideText(years, 'hide');
//     d3.selectAll('[data-name="text2020"]').selectAll('text').attr('opacity', 1);

//     d3.selectAll('circle').attr('opacity', 0.3);
//     d3.select(this).attr('opacity', 1);
//   })
//   .on('mouseout', () => {
//     graphicDefault();
//   });

// d3.selectAll('[data-name="circ2021"]')
//   .on('mouseover', function () {
//     hideText(years, 'hide');
//     d3.selectAll('[data-name="text2021"]').selectAll('text').attr('opacity', 1);

//     d3.selectAll('circle').attr('opacity', 0.3);
//     d3.select(this).attr('opacity', 1);
//   })
//   .on('mouseout', () => {
//     graphicDefault();
//   });

// d3.selectAll('[data-name="circ2022"]')
//   .on('mouseover', function () {
//     hideText(years, 'hide');
//     d3.selectAll('[data-name="text2022"]').selectAll('text').attr('opacity', 1);

//     d3.selectAll('circle').attr('opacity', 0.3);
//     d3.select(this).attr('opacity', 1);
//   })
//   .on('mouseout', () => {
//     graphicDefault();
//   });

// d3.selectAll('[data-name="circ2023"]')
//   .on('mouseover', function () {
//     console.log('yo!!!');
//     hideText(years, 'hide');
//     d3.selectAll('[data-name="text2023"]').selectAll('text').attr('opacity', 1);

//     d3.selectAll('circle').attr('opacity', 0.3);
//     d3.select(this).attr('opacity', 1);
//   })
//   .on('mouseout', () => {
//     graphicDefault();
//   });

// graphicDefault();


const years = [2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023];

function hideText(years, show) {
  if (show == 'hide') {
    years.forEach((d) => {
      d3.selectAll(`[data-name="text${d}"]`).selectAll('path').attr('opacity', 0);
      // d3.select(`#text${d}`).selectAll('text').attr('opacity', 0);
    });
  } else {
    years.forEach((d) => {
      d3.selectAll(`[data-name="text${d}"]`).selectAll('path').attr('opacity', 1);
      // d3.select(`#text${d}`).selectAll('text').attr('opacity', 1);
    });
  }
}

function graphicDefault() {
  // show all circles
  d3.selectAll('circle').attr('opacity', 1);
  // show all years
  hideText(years, 'hide');

  if (window.innerWidth < 500) {
    d3.selectAll('[data-name="text2014"]')
      .selectAll('path').attr('opacity', 1)
      .attr('fill', 'white');
    // .style('text-shadow', 'text-shadow: -1px -1px 2px #fff, 1px -1px 2px #fff, -1px 1px 2px #fff, 1px 1px 2px #fff');
    d3.selectAll('[data-name="text2023"]').selectAll('path').attr('opacity', 1);
  } else {
    d3.selectAll('[data-name="text2014"]').selectAll('path').attr('opacity', 1)
      .attr('fill', 'white');
    // .style('text-shadow', '-1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff');
    d3.selectAll('[data-name="text2023"]').selectAll('path').attr('opacity', 1);
  }

  // d3.selectAll('[data-name="text2014"]').selectAll('text').attr('display', 'block');
}

// d3.selectAll('#circ2014')
d3.selectAll('[data-name="circ2014"]')
  .on('mouseover', function () {
    // hide all text
    hideText(years, 'hide');
    // except selected year
    d3.selectAll('[data-name="text2014"]').selectAll('path').attr('opacity', 1).attr('fill', 'black');

    // hide all circles
    d3.selectAll('circle').attr('opacity', 0.3);
    // except selected year
    d3.select(this).attr('opacity', 1);
  })
  .on('mouseout', () => {
    graphicDefault();
  });

d3.selectAll('[data-name="circ2015"]')
  .on('mouseover', function () {
    hideText(years, 'hide');
    d3.selectAll('[data-name="text2015"]').selectAll('path').attr('opacity', 1);

    d3.selectAll('circle').attr('opacity', 0.3);
    d3.select(this).attr('opacity', 1);
  })
  .on('mouseout', () => {
    graphicDefault();
  });

d3.selectAll('[data-name="circ2016"]')
  .on('mouseover', function () {
    hideText(years, 'hide');
    d3.selectAll('[data-name="text2016"]').selectAll('path').attr('opacity', 1);

    d3.selectAll('circle').attr('opacity', 0.3);
    d3.select(this).attr('opacity', 1);
  })
  .on('mouseout', () => {
    graphicDefault();
  });

d3.selectAll('[data-name="circ2017"]')
  .on('mouseover', function () {
    hideText(years, 'hide');
    d3.selectAll('[data-name="text2017"]').selectAll('path').attr('opacity', 1);

    d3.selectAll('circle').attr('opacity', 0.3);
    d3.select(this).attr('opacity', 1);
  })
  .on('mouseout', () => {
    graphicDefault();
  });

d3.selectAll('[data-name="circ2018"]')
  .on('mouseover', function () {
    hideText(years, 'hide');
    d3.selectAll('[data-name="text2018"]').selectAll('path').attr('opacity', 1);

    d3.selectAll('circle').attr('opacity', 0.3);
    d3.select(this).attr('opacity', 1);
  })
  .on('mouseout', () => {
    graphicDefault();
  });

d3.selectAll('[data-name="circ2019"]')
  .on('mouseover', function () {
    hideText(years, 'hide');
    d3.selectAll('[data-name="text2019"]').selectAll('path').attr('opacity', 1);

    d3.selectAll('circle').attr('opacity', 0.3);
    d3.select(this).attr('opacity', 1);
  })
  .on('mouseout', () => {
    graphicDefault();
  });

d3.selectAll('[data-name="circ2020"]')
  .on('mouseover', function () {
    hideText(years, 'hide');
    d3.selectAll('[data-name="text2020"]').selectAll('path').attr('opacity', 1);

    d3.selectAll('circle').attr('opacity', 0.3);
    d3.select(this).attr('opacity', 1);
  })
  .on('mouseout', () => {
    graphicDefault();
  });

d3.selectAll('[data-name="circ2021"]')
  .on('mouseover', function () {
    hideText(years, 'hide');
    d3.selectAll('[data-name="text2021"]').selectAll('path').attr('opacity', 1);

    d3.selectAll('circle').attr('opacity', 0.3);
    d3.select(this).attr('opacity', 1);
  })
  .on('mouseout', () => {
    graphicDefault();
  });

d3.selectAll('[data-name="circ2022"]')
  .on('mouseover', function () {
    hideText(years, 'hide');
    d3.selectAll('[data-name="text2022"]').selectAll('path').attr('opacity', 1);

    d3.selectAll('circle').attr('opacity', 0.3);
    d3.select(this).attr('opacity', 1);
  })
  .on('mouseout', () => {
    graphicDefault();
  });

d3.selectAll('[data-name="circ2023"]')
  .on('mouseover', function () {
    console.log('yo!!!');
    hideText(years, 'hide');
    d3.selectAll('[data-name="text2023"]').selectAll('path').attr('opacity', 1);

    d3.selectAll('circle').attr('opacity', 0.3);
    d3.select(this).attr('opacity', 1);
  })
  .on('mouseout', () => {
    graphicDefault();
  });

graphicDefault();
